export default function index (idConcesion, concesionesArray){
    let index = 0;
    for (let i = 0; i < concesionesArray.length; i++) {
        if (concesionesArray[i].idConcesion === Number(idConcesion)) {
            index = i;
            break;
        }
    }
    return index;
}